<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px">
        <div>
          <el-form-item label="原因" prop="remark" label-width="90px" :rules="[$validate.textarea(100)]">
            <el-input type="textarea" maxlength="100" v-model="form.remark" show-word-limit rows="4" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'unpass-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: null
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      // if (!this.Tool.isNull(this.row)) {
      //   let info = JSON.parse(JSON.stringify(this.row))
      //   this.form = {}
      // } else {
      this.form = {}
      // }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let param = {
          isPass: 0,
          remark: this.form.remark,
          logId: this.row.logId
        }
        await this.$HTTP.ApiExamAudit.auditReport(param)
        this.$message({ type: 'success', message: '操作成功' })
        this.$emit('close', this.form)
      }
    }
  }
}
</script>
